var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-et-alarm"},[_c('p',[_vm._v(_vm._s(_vm.computedDescription))]),_c('alarm-status',{attrs:{"alarm":_vm.alarm,"alarm-active":_vm.computedAlarmIsActive}}),_c('hr'),(_vm.computedAlarmIsActive)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }